<!-- eslint-disable max-lines -->
<template>
    <paper class="evaluate-query">
        <m-pane
            ref="tablePage"
            pageID="evaluate-query"
            searchId="evaluate-query-search"
            :loading="loading"
            :totalData="totalData"
            :searchTotalTitle="config.searchTotalTitle"
            :config="config"
            :pageTotal="pageTotal"
            @searchChange="searchChange"
            @selectChange="selectChange"
            @sizeChange="sizeChange"
            @pageChange="pageChange"
            >
            <div slot='table-module-btn'>
                <el-tooltip effect='dark' content='导出' placement='bottom'>
                    <el-button icon='icon-daochu' size='mini' @click='exportData'></el-button>
                </el-tooltip>
            </div>
        </m-pane>
    </paper>
</template>

<script>
/* eslint-disable camelcase */
/* eslint-disable max-depth */
/* eslint-disable operator-linebreak */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */

import mPane from '@/components/otpPanel';
import config from './config.js';
import paper from '@/components/core/paper/Paper';
import api from '@/modules/transport/otp/api/evaluateQuery.js';
import { portalAdvice } from '@/modules/transport/otp/api/export.js';
import dayjs from 'dayjs';
import { dictWithUrl } from '@/components/lots/api.js';

export default {
    components: {
        paper,
        mPane
    },
    data() {
        return {
            loading: false,
            pageTotal: 0,
            totalData: [],
            checkedData: [],
            config,
            searchParams: {
                pageSize: 10,
                pageNo: 1
            }
        };
    },
    methods: {
        exportData() {
            if (!this.checkedData.length) {
                this.$message.warning('请选择要导出的数据');
                return false;
            }
            portalAdvice(this.checkedData.map(item => item.id)).then(res => {
                if (res) {
                    this.$message.success('已发送导出请求，请稍后到右上角“用户文件列表”中下载');
                }
            });
        },
        selectChange(data) {
            this.checkedData = data;
        },
        searchChange(
            {
                customerOrderNo,
                createTime,
                adviceChannel,
                adviceType,
                vehicleCard,
                driver,
                emergencyLevel,
                waybillNo,
                businessType
            } = {}) {
            this.searchParams.pageNo = 1;
            this.searchParams = { ...this.searchParams,
                customerOrderNo,
                createTimeStart: createTime && dayjs(createTime[0]).format('YYYY-MM-DD HH:mm:ss'),
                createTimeEnd: createTime && dayjs(createTime[1]).format('YYYY-MM-DD HH:mm:ss'),
                adviceChannel,
                adviceType,
                vehicleCard,
                driver,
                emergencyLevel,
                waybillNo,
                businessType
            };
            this.getDataList();
        },
        pageChange(pageNo) {
            this.searchParams.pageNo = pageNo;
            this.getDataList();
        },
        sizeChange(pageSize) {
            this.searchParams.pageNo = 1;
            this.searchParams.pageSize = pageSize;
            this.getDataList();
        },
        _validateSearchParams(data) {
            if (!data.createTimeStart) {
                return '创建时间 不可为空';
            }
            const beginDate = dayjs(data.createTimeStart).valueOf() || 0;
            const endDate = dayjs(data.createTimeEnd).valueOf() || 0;
            const differenceValue = endDate - beginDate;
            const maxDay62 = 1000 * 60 * 60 * 24 * 62;
            if (differenceValue > maxDay62) {
                return '按时间查询时，时间跨度不可超过两个月！';
            }
        },
        async  getDataList() {
            const dict = await dictWithUrl('ADVICE_CHANNEL,ADVICE_TYPE,EMERGENCY_LEVEL,BUSINESS_TYPE');
            const dictData = dict.data;
            const msg = this._validateSearchParams(this.searchParams);
            if (msg) return this.$message.warning(msg);
            this.loading = true;
            api.portalAdvices(this.searchParams).then(res => {
                if (res) {
                    if (res.data.totalPage !== 0 && this.searchParams.pageNo > res.data.totalPage) {
                        this.searchParams.pageNo = res.data.totalPage;
                        this.getDataList();
                        return false;
                    }
                    res.data.list.forEach(item => {
                        item.adviceChannelName = dictData.ADVICE_CHANNEL[item.adviceChannel] || item.adviceChannel;
                        item.adviceTypeName = dictData.ADVICE_TYPE[item.adviceType] || item.adviceType;
                        item.emergencyLevelName = dictData.EMERGENCY_LEVEL[item.emergencyLevel] || item.emergencyLevel;
                        item.businessTypeName = dictData.BUSINESS_TYPE[item.businessType] || item.businessType;
                    });
                    this.totalData = res.data.list;
                    this.pageTotal = res.data.totalCount;
                }
            }).finally(() => {
                this.loading = false;
            });
        }
    },
    mounted () {
        // this.getDataList();
        this.$refs.tablePage.$refs.searchList.onSearchChange();
    }
};
</script>
